import Queue from 'promise-queue';

const QUEUE_MAX_CONCURRENT = 5;
const QUEUE_MAX_SIZE = 99;

const queue = new Queue(QUEUE_MAX_CONCURRENT, QUEUE_MAX_SIZE);

export default queue;
